export default __webpack_public_path__ + "static/asharita-37888fbc2c6d6b7f25dbcaa592f73759.png";